import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { CopySiteAndTransformSettings } from '../../models/copy-site-and-transform-settings.model';
import { DataCollection } from '../../models/site-content/data-collection.model';
import { CopySiteService } from '../../services/copy-site.service';
import { DataCollectionService } from '../../services/data-collection.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-copy-site-and-transform',
    templateUrl: './copy-site-and-transform.component.html',
    styleUrls: ['./copy-site-and-transform.component.scss'],
    standalone: false
})
export class CopySiteAndTransformComponent implements OnInit {

    // NOTE TO OTHER DEVELOPERS: These site IDs are specific to pharvey's current environment, if you end up working on one of these sites
    // you'll need to first import it (using the LoadCollectExerciseFromJson solution) and then update the id of the site here
    readonly MY_TEST_SITE_ID: number = 8;
    readonly FOUR_IDENTICAL_DROPDOWNS_SITE_ID: number = 46
    readonly SES_CDP_Registry_SITE_ID: number = 10;

    
    // Initial got this on one of the FIs: "String does not match pattern ^([0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*@([0-9a-zA-Z][-\\w]*[0-9a-zA-Z]\\.)+[a-zA-Z]{2,9})$"
    // The field was empty, so I modified server-side code
    readonly OPM_SES_Situational_Mentoring_Database_SITE_ID: number = 87;

    // Come back to this one...
    // Errored out with inner exception of {"'\u001a', hexadecimal value 0x1A, is an invalid character."}
    // Stacktrace: "   at System.Xml.Serialization.XmlSerializer.Serialize(XmlWriter xmlWriter, Object o, XmlSerializerNamespaces namespaces, String encodingStyle, String id)\r\n   at System.Xml.Serialization.XmlSerializer.Serialize(XmlWriter xmlWriter, Object o, XmlSerializerNamespaces namespaces)\r\n   at Collect.vNext.ExportImportClasses.HelperClasses.XmlUtility.WriteViewModelProperties(Object viewModelObject, StreamWriter writer, XmlFormatType FileFormat, Boolean bAppendNewline) in P:\\Workspace\\MAXDSS\\DotNetCore\\Solutions\\Collect.vNext\\Collect.vNext.ExportImportClasses\\HelperClasses\\XmlUtility.cs:line 74\r\n   at Collect.vNext.ExportImport.Core.SiteExporterImporter.WriteViewModelProperties(Object viewModelObject, StreamWriter writer, XmlFormatType FileFormat, Boolean bAppendNewline) in P:\\Workspace\\MAXDSS\\DotNetCore\\Solutions\\Collect.vNext\\Collect.vNext.ExportImport\\Core\\SiteExporterImporter.cs:line 580\r\n   at Collect.vNext.ExportImport.Core.SiteExporterImporter.WriteFormInstanceProperties(FormInstance formInstance, StreamWriter formInstanceWriter, XmlFormatType FileFormat) in P:\\Workspace\\MAXDSS\\DotNetCore\\Solutions\\Collect.vNext\\Collect.vNext.ExportImport\\Core\\SiteExporterImporter.cs:line 588\r\n   at Collect.vNext.ExportImport.Core.SiteExporterImporter.VisitFormInstance(FormInstance formInstance, Boolean& structureModifiedFlag, List`1& modifiedFormInstances) in P:\\Workspace\\MAXDSS\\DotNetCore\\Solutions\\Collect.vNext\\Collect.vNext.ExportImport\\Core\\SiteExporterImporter.cs:line 132\r\n   at Collect.vNext.ExportImport.CustomExporters.FormAndFormInstanceTransformerExporter.VisitFormInstance(FormInstance formInstance, Boolean& structureModifiedFlag, List`1& modifiedFormInstances) in P:\\Workspace\\MAXDSS\\DotNetCore\\Solutions\\Collect.vNext\\Collect.vNext.ExportImport\\CustomExporters\\FormAndFormInstanceTransformerExporter.cs:line 267\r\n   at Collect.vNext.ExportImport.ApiNavigator.CollectSiteNavigator.TourFormInstances(IFormInstanceService FormInstanceService, ICollection`1 FormInstances, ISiteVisitor Visitor) in P:\\Workspace\\MAXDSS\\DotNetCore\\Solutions\\Collect.vNext\\Collect.vNext.ExportImport\\ApiNavigator\\CollectSiteNavigator.cs:line 878\r\n   at Collect.vNext.ExportImport.ApiNavigator.CollectSiteNavigator.TourFolder(DataCollection Site, ContentServiceRefs ServiceRefs, Folder Folder, Boolean bVisitFolderFormInstances, ISiteVisitor Visitor) in P:\\Workspace\\MAXDSS\\DotNetCore\\Solutions\\Collect.vNext\\Collect.vNext.ExportImport\\ApiNavigator\\CollectSiteNavigator.cs:line 797\r\n   at Collect.vNext.ExportImport.ApiNavigator.CollectSiteNavigator.TourFolder(DataCollection Site, ContentServiceRefs ServiceRefs, Folder Folder, Boolean bVisitFolderFormInstances, ISiteVisitor Visitor) in P:\\Workspace\\MAXDSS\\DotNetCore\\Solutions\\Collect.vNext\\Collect.vNext.ExportImport\\ApiNavigator\\CollectSiteNavigator.cs:line 826\r\n   at Collect.vNext.ExportImport.ApiNavigator.CollectSiteNavigator.TourFolder(DataCollection Site, ContentServiceRefs ServiceRefs, Folder Folder, Boolean bVisitFolderFormInstances, ISiteVisitor Visitor) in P:\\Workspace\\MAXDSS\\DotNetCore\\Solutions\\Collect.vNext\\Collect.vNext.ExportImport\\ApiNavigator\\CollectSiteNavigator.cs:line 826\r\n   at Collect.vNext.ExportImport.ApiNavigator.CollectSiteNavigator.TourSiteContent(ContentServiceRefs ServiceRefs, DataCollection Site, ISiteVisitor Visitor) in P:\\Workspace\\MAXDSS\\DotNetCore\\Solutions\\Collect.vNext\\Collect.vNext.ExportImport\\ApiNavigator\\CollectSiteNavigator.cs:line 735\r\n   at Collect.vNext.ExportImport.ApiNavigator.CollectSiteNavigator.TourSite(MetadataServiceRefs MetadataServiceRefs, ContentServiceRefs ContentServiceRefs, DataCollection Site, ISiteVisitor Visitor, Boolean bVisitSiteMetadata, Boolean bVisitSiteContent) in P:\\Workspace\\MAXDSS\\DotNetCore\\Solutions\\Collect.vNext\\Collect.vNext.ExportImport\\ApiNavigator\\CollectSiteNavigator.cs:line 579\r\n   at Collect.vNext.ExportImport.ApiNavigator.CollectSiteNavigator.GiveSiteTourTo(ISiteVisitor Visitor, Boolean bVisitSiteMetadata, Boolean bVisitSiteContent) in P:\\Workspace\\MAXDSS\\DotNetCore\\Solutions\\Collect.vNext\\Collect.vNext.ExportImport\\ApiNavigator\\CollectSiteNavigator.cs:line 80\r\n   at Collect.vNext.API.Controllers.CopySiteController.DoExportSite(String jobKey, String correlationId, Int32 sourceSiteId, String jsonConfig, Int32 countOfFormInstancesToExport) in P:\\Workspace\\MAXDSS\\DotNetCore\\Solutions\\Collect.vNext\\Collect.vNext.API\\Controllers\\CopySiteController.cs:line 832"
    // It occurred on --> Processing 2029 of 2830) --> Transforming "JP Morgan Chase Payroll Cards 1.31.2014" (21658)
    readonly CFPB_FTC_Data_Entry_Portal_SITE_ID: number = 21;
    readonly OPM_Federal_Coaching_Network_SITE_ID: number = 11;
    readonly CIO_KNOWLEDGE_PORTAL_SITE_ID: number = 79;
    readonly TINY_SITE_ID = 281;
    readonly TWO_DROPDOWNS_ID = 241;
    readonly DEFC_SITE_ID = 376;

    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!! SET SITE TO RUN ON HERE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    // This is where you change the Site you want to test.
    // Change the param passed to getSettingsFor() to one of the constants above
    private settings: CopySiteAndTransformSettings;
    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    countOfFormInstanceToExport: UntypedFormControl;
    json: UntypedFormControl;
    siteId: UntypedFormControl;
    newName: UntypedFormControl;
    jobKey: string;

    sites: DataCollection[];
    currentSite: number;

    constructor(
        private dataCollectionService: DataCollectionService,
        private copySiteService: CopySiteService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.currentSite = this.route.snapshot.params.siteId;
    }

    ngOnInit(): void {
        this.dataCollectionService.getAll().then(x => {
            this.sites = x;
        });
        this.settings = this.getSettingsFor(this.route.snapshot.params.siteId);
        if (!this.settings) {
            alert(`The site ID of ${this.currentSite} is not configured for transformation by this tool.`)
            return;
        }
        this.countOfFormInstanceToExport = new UntypedFormControl(this.settings.countOfFormInstancesToExport);
        this.json = new UntypedFormControl(this.settings.jsonConfig);
        this.siteId = new UntypedFormControl(this.settings.dataCollectionId);
        this.newName = new UntypedFormControl(this.settings.newName);
    }

    doCopyAndTransform() {
        let settings = new CopySiteAndTransformSettings(this.siteId.value, this.newName.value, this.json.value, this.countOfFormInstanceToExport.value);
        this.copySiteService.copyAndTransformSite(settings).then(res => this.jobKey = res.jobKey);
    }

    doCopy() {
        this.copySiteService.copySite(this.siteId.value, this.newName.value).then(res => this.jobKey = res.jobKey);
    }

    doExportAndTransform() {
        let settings = new CopySiteAndTransformSettings(this.siteId.value, this.newName.value, this.json.value, this.countOfFormInstanceToExport.value);
        this.copySiteService.exportAndTransformSite(settings).then(res => this.jobKey = res.jobKey);
    }


    // !!!!!!!! NOTE TO OTHER DEVELOPERS !!!!!!!!!
    // BESIDES THE 'test' and '4dropdowns' settings, the settings below are for faceted search sites
    // WHICH HAVE TO HAVE ALREADY BEEN IMPORTED INTO YOUR VNEXT INSTANCE USING THE Collect.vNext.LoadCollectExerciseFromJson Solution
    // In other words, this all presupposes you have a site already imported that you want to transform
    getSettingsFor(siteId: number): CopySiteAndTransformSettings {
        if (siteId == this.TWO_DROPDOWNS_ID) {
            return new CopySiteAndTransformSettings(siteId, "TWO DROPDOWNS COPY ", "");
        }
        else if (siteId == this.TINY_SITE_ID) {
            let json = `{
  "CustomTransformer": "FormAndFormInstanceTransformerExporter",
  "User": "O001178",
  "Strategy": "CreateNew",
  "FormTransformationStrategy": "OneFormPerForm",
  "Comment": "Options for FormTransformationStrategy: OneFormPerFormField, OneFormPerForm",
  "FormInstanceTransformationStrategy": "KeepOirginalStructure",
  "Comment2": "Options for FormInstanceTransformationStrategy: SplitFormInstanceIntoFolder, KeepOirginalStructure",
  "FormFields": {
    "GRID": {
      "Include": "true",
      "Columns": 2,
      "ExplodeGridChildFormFields": "true"
    },
    "Cascade": {
      "Include": "true",
      "Columns": 1,
      "DoNotTransform": "true"
    }
  }
}`;
            return new CopySiteAndTransformSettings(siteId, "TINY COPY ", json);
        }
        else if (siteId == this.DEFC_SITE_ID) {
            let json = `{
  "CustomTransformer": "FormAndFormInstanceTransformerExporter",
  "User": "O001178",
  "Strategy": "CreateNew",
  "FormTransformationStrategy": "OneFormPerForm",
  "Comment": "Options for FormTransformationStrategy: OneFormPerFormField, OneFormPerForm",
  "FormInstanceTransformationStrategy": "KeepOirginalStructure",
  "Comment2": "Options for FormInstanceTransformationStrategy: SplitFormInstanceIntoFolder, KeepOirginalStructure",
  "FormFields": {
    "DEFC Properties": {
      "Include": "true",
      "Columns": 4,
      "ExplodeGridChildFormFields": "true"
    },
    "Public Laws": {
      "Include": "true",
      "Columns": 1,
      "DoNotTransform": "true"
    },
    "Associated Treasury Accounts": {
      "Include": "true",
      "Columns": 1,
      "DoNotTransform": "true"
    },
    "Primary or All Treasury Accounts": {
      "Include": "true",
      "Columns": 1,
      "DoNotTransform": "true"
    },
    "OMB Account Numbers": {
      "Include": "true",
      "Columns": 1,
      "DoNotTransform": "true"
    },
    "USSGL and Attribute Exceptions": {
      "Include": "true",
      "Columns": 1,
      "DoNotTransform": "true"
    }
  }
}`;
            return new CopySiteAndTransformSettings(siteId, "DEFC > ", json, 1);
        }
        else if (siteId == this.CFPB_FTC_Data_Entry_Portal_SITE_ID) {
            let json = `{
  "CustomTransformer":"FormAndFormInstanceTransformerExporter",
  "User": "O001178",
  "Strategy": "CreateNew",
  "FormTransformationStrategy": "OneFormPerForm",
  "Comment": "Options for FormTransformationStrategy: OneFormPerFormField, OneFormPerForm",
  "FormInstanceTransformationStrategy": "KeepOirginalStructure",
  "Comment2": "Options for FormInstanceTransformationStrategy: SplitFormInstanceIntoFolder, KeepOirginalStructure",
  "FormFields": {
    "Entity Information": {
      "Include": "true",
      "Columns": 3,
      "ExplodeGridChildFormFields": "true"
    },
    "Topics": {
      "Include": "true",
      "Columns": 1,
      "ConvertAllDropdownsToOneMultiSelectDropdown": "true"
    },
    "Agency Information": {
      "Include": "true",
      "Columns": 3,
      "ExplodeGridChildFormFields": "true"
    },
    "Enforcement Related Notifications": {
      "Include": "true",
      "Columns": 3,
      "ExplodeGridChildFormFields": "true"
    },
    "Warning Letter Notifications": {
      "Include": "true",
      "Columns": 1,
      "DoNotTransform": "true"
    },
    "Amended Notices": {
      "Include": "true",
      "Columns": 1,
      "DoNotTransform": "true"
    },
    "Entity Information 2": {
      "Include": "true",
      "Columns": 1,
      "DoNotTransform": "true"
    },
    "Attachments": {
      "Include": "true",
      "IncludeContent" : "false",
      "DoNotTransform": "true"
    },
    "Supervision Related Notifications": {
      "Include": "true",
      "DoNotTransform": "true"
    }
  }
}`;
            return new CopySiteAndTransformSettings(siteId, null, json);
        }
        else if (siteId == this.SES_CDP_Registry_SITE_ID) {
            let json = `{
  "CustomTransformer":"FormAndFormInstanceTransformerExporter",
  "User": "O001178",
  "Strategy": "CreateNew",
  "FormTransformationStrategy": "OneFormPerForm",
  "Comment": "Options for FormTransformationStrategy: OneFormPerFormField, OneFormPerForm",
  "FormInstanceTransformationStrategy": "KeepOirginalStructure",
  "Comment2": "Options for FormInstanceTransformationStrategy: SplitFormInstanceIntoFolder, KeepOirginalStructure",
  "FormFields": {
    "Basic Information": {
      "Include": "true",
      "Columns": 4,
      "ExplodeGridChildFormFields": "true"
    },
    "Occupational Series of Interest": {
      "Include": "true",
      "Columns": 1,
      "ExplodeGridChildFormFields": "true",
      "FieldTransforms": {
        "Collect.vNext.FieldDefinitions.DropDownFieldDefinition": "Collect.vNext.FieldDefinitions.MultiDropDownFieldDefinition"
      }
    },
    "Current Technical Competencies": {
      "Include": "true",
      "DoNotTransform": "true"
    },
    "Attachments": {
      "Include": "true",
      "DoNotTransform": "true"
    }
  }
}`;
            return new CopySiteAndTransformSettings(siteId, null, json);
        }
        else if (siteId == this.OPM_SES_Situational_Mentoring_Database_SITE_ID) {
            let json = `{
  "CustomTransformer":"FormAndFormInstanceTransformerExporter",
  "User": "O001178",
  "Strategy": "CreateNew",
  "FormTransformationStrategy": "OneFormPerForm",
  "Comment": "Options for FormTransformationStrategy: OneFormPerFormField, OneFormPerForm",
  "FormInstanceTransformationStrategy": "KeepOirginalStructure",
  "Comment2": "Options for FormInstanceTransformationStrategy: SplitFormInstanceIntoFolder, KeepOirginalStructure",
  "FormFields": {
    "Basic Information": {
      "Include": "true",
      "Columns": 4,
      "ExplodeGridChildFormFields": "true"
    },
    "HIGHLY PROFICIENT LEADERSHIP COMPETENCIES": {
      "Include": "true",
      "Columns": 2,
      "ExplodeGridChildFormFields": "true",
      "FieldTransforms": {
        "Collect.vNext.FieldDefinitions.DropDownFieldDefinition": "Collect.vNext.FieldDefinitions.MultiDropDownFieldDefinition"
      }
    },
    "Topic Areas": {
      "Include": "true",
      "Columns": 1,
      "ExplodeGridChildFormFields": "true",
      "FieldTransforms": {
        "Collect.vNext.FieldDefinitions.DropDownFieldDefinition": "Collect.vNext.FieldDefinitions.MultiCheckBoxFieldDefinition"
      }
    },
    "Attachments": {
      "Include": "true"
    }
  }
}`;
            return new CopySiteAndTransformSettings(siteId, null, json);
        }
        else if (siteId == this.CIO_KNOWLEDGE_PORTAL_SITE_ID) {
            let json = `{
  "CustomTransformer":"FormAndFormInstanceTransformerExporter",
  "User": "O001178",
  "Strategy": "CreateNew",
  "FormTransformationStrategy": "OneFormPerForm",
  "Comment": "Options for FormTransformationStrategy: OneFormPerFormField, OneFormPerForm",
  "FormInstanceTransformationStrategy": "KeepOirginalStructure",
  "Comment2": "Options for FormInstanceTransformationStrategy: SplitFormInstanceIntoFolder, KeepOirginalStructure",
  "FormFields": {
    "Document Information":{
        "Include":"true",
        "Columns":4,
        "ExplodeGridChildFormFields": "true"
    },
    "Agency":{
        "Include":"true",
        "Columns": 1,
        "DoNotTransform":"true"
    },
    "Contact":{
        "Include":"true",
        "Columns": 1,
        "DoNotTransform":"true"
    },
    "Highlights":{
        "Include":"true",
        "Columns": 1,
        "DoNotTransform":"true"
    },
    "References":{
        "Include":"true",
        "Columns": 1,
        "DoNotTransform":"true"
    },
    "Highlights":{
        "Include":"true",
        "Columns": 1,
        "DoNotTransform":"true"
    },
    "Document": {
      "Include": "true",
        "Columns": 1,
        "DoNotTransform":"true"
    },
    "Documentation Information 2":{
        "Include":"true",
        "Columns":3,
        "ExplodeGridChildFormFields": "true"
    }
  }
}`;
            return new CopySiteAndTransformSettings(siteId, null, json);
        }
        else if (siteId == this.OPM_Federal_Coaching_Network_SITE_ID) {
            let json = `{
  "CustomTransformer":"FormAndFormInstanceTransformerExporter",
  "User": "O001178",
  "Strategy": "CreateNew",
  "FormTransformationStrategy": "OneFormPerForm",
  "Comment": "Options for FormTransformationStrategy: OneFormPerFormField, OneFormPerForm",
  "FormInstanceTransformationStrategy": "KeepOirginalStructure",
  "Comment2": "Options for FormInstanceTransformationStrategy: SplitFormInstanceIntoFolder, KeepOirginalStructure",
  "FormFields": {
    "Basic Information":{
        "Include":"true",
        "Columns":3,
        "ExplodeGridChildFormFields": "true"
    },
    "Attachment": {
      "Include": "true"
    }
  }
}`;
            return new CopySiteAndTransformSettings(siteId, null, json);
}
        // USED FOR TESTING
        else if (siteId == this.MY_TEST_SITE_ID) {
            let json = `{
  "CustomTransformer":"FormAndFormInstanceTransformerExporter",
  "User": "O001178",
  "Strategy": "CreateNew",
  "FormTransformationStrategy": "OneFormPerForm",
  "Comment": "Options for FormTransformationStrategy: OneFormPerFormField, OneFormPerForm",
  "FormInstanceTransformationStrategy": "KeepOirginalStructure",
  "Comment2": "Options for FormInstanceTransformationStrategy: SplitFormInstanceIntoFolder, KeepOirginalStructure",
  "FormFields": {
    "Shorty": {
      "Include": "false",
      "Columns": 1,
      "DoNotTransform":"true"
    },
    "Keep this Grid as is": {
      "Include": "true",
      "Columns": 1,
      "DoNotTransform": "true"
    },
    "Explode this Grid": {
      "Include": "false",
      "Columns": 1,
      "ExplodeGridChildFormFields": "true"
    },
    "Integrer": {
      "Include": "false",
      "Columns": 1,
      "DoNotTransform": "true"
    }
  }
}`;
            return new CopySiteAndTransformSettings(siteId, null, json);


        }
        // USED FOR TESTING
        else if (siteId == this.FOUR_IDENTICAL_DROPDOWNS_SITE_ID) {
            let json = `{
  "CustomTransformer":"FormAndFormInstanceTransformerExporter",
  "User": "O001178",
  "Strategy": "CreateNew",
  "FormTransformationStrategy": "OneFormPerForm",
  "Comment": "Options for FormTransformationStrategy: OneFormPerFormField, OneFormPerForm",
  "FormInstanceTransformationStrategy": "KeepOirginalStructure",
  "Comment2": "Options for FormInstanceTransformationStrategy: SplitFormInstanceIntoFolder, KeepOirginalStructure",
  "FormFields": {
    "Four Identical Dropdowns": {
      "Include": "true",
      "Columns": 1,
      "ConvertAllDropdownsToOneMultiSelectDropdown": "true"
    },
    "Plain Old Grid": {
      "Include": "true",
      "Columns": 1,
      "DoNotTransform": "true"
    },
    "Explode Me":{
        "Include":"true",
        "Columns": 3,
        "ExplodeGridChildFormFields": "true"
    }
  }
}`;
            return new CopySiteAndTransformSettings(siteId, null, json);
        }
    }
}
